/* eslint-disable no-unused-vars, array-bracket-newline */
import { useCallback } from 'react';
import DesktopTable from '../../../molecules/Table/DesktopTable';
import Text from '../../../atoms/Text';
import OpenOrdersActions from './Actions';
import { formatTimestamp } from '../formatters';
import { useTableData } from './useTableData';
import { decorateCexHistoryOrderStatus } from '../../../helpers/decorators';
import Badge from '../../../molecules/Badge';
import { ICexOpenOrder } from '.';
import NumberDisplay from '../../../molecules/NumberDisplay';
import { EXCHANGE_MAPPING } from '../../ConnectedWallet/SideBarWallet/CEXWallet/ExchangeSelector/helpers';
import { getExchangeNameFromType } from '../../../reducers/cex_trading';

export const LS_OPEN_ORDERS_HIDDEN_COLUMNS_KEY =
  'kattana-simple.open_orders_table_columns_hidden';
export const LS_OPEN_ORDERS_KEY = 'kattana-simple.open_orders_table_columns';

interface IOpenOrdersTableProps {
  orders: ICexOpenOrder[];
  base: string;
  quote: string;
  loading: boolean;
  timezone?: string;
  width?: number;
  onCancel(id: string): void;
}

const sellClassName = 'row--Sell text--red-600';
const buyClassName = 'row--Buy text--green-600';

export const openOrderStatusToBadgeKlass = (status: number): any => {
  switch (status) {
  case 1:
    return 'green';
  case 5:
    return 'red';
  default:
    return 'grey';
  }
};

/**
 * Implements a table with trades
 * @param param0
 */
const OpenOrdersTable = ({
  orders,
  base,
  quote,
  loading,
  timezone,
  width,
  onCancel,
}: IOpenOrdersTableProps) => {
  const { columns, data, tableColumnsWidth } = useTableData({
    orders,
    base,
    quote,
  });

  const renderCell = (cell: any) => {
    switch (cell.column.id) {
    case 'updatedAt':
      return <Text size={12}>{formatTimestamp(cell.value, timezone)}</Text>;
    case 'baseAmount':
    case 'fillBaseAmount':
    case 'price':
      return <NumberDisplay value={cell.value} textProps={{ size: 12 }} />;
    case 'type':
      return <Text size={12}>{cell.value === 1 ? 'market' : 'limit'}</Text>;
    case 'exchange':
      return (
        <Text size={12}>
          {EXCHANGE_MAPPING[getExchangeNameFromType(cell.value)].label}
        </Text>
      );
    case 'status':
      return (
        <Badge
          variant='fill'
          klass={openOrderStatusToBadgeKlass(cell.value)}
          text={decorateCexHistoryOrderStatus(cell.value)}
        />
      );
    case 'actions':
      return <OpenOrdersActions id={cell.value} onCancel={onCancel} />;
    default:
      return <Text size={12}>{cell.value}</Text>;
    }
  };

  const getClassNameForRow = useCallback((row: any) => {
    if (row.side === 1) {
      return buyClassName;
    }
    return sellClassName;
  }, []);

  return (
    <DesktopTable
      hiddenColumnsKey={LS_OPEN_ORDERS_HIDDEN_COLUMNS_KEY}
      dataKey={LS_OPEN_ORDERS_KEY}
      title='open_orders'
      tableColumnsWidth={tableColumnsWidth}
      tableWidth={width || 0}
      columns={columns}
      defaultSortedColumn={{ id: 'updatedAt', desc: true }}
      data={data}
      hiddenColumns={[]}
      loading={loading}
      getClassNameForRow={getClassNameForRow}
      renderCell={renderCell}
    />
  );
};

export default OpenOrdersTable;
